import { getCookieWithKey } from 'src/cookies';
import {
  COOKIE_CATEGORY_CONSENT_ACCEPTED_VALUE,
  COOKIE_CONSENT_COOKIE_NAME,
} from 'src/cookies/consent-cookie';
import type { OnCookieConsentChangeArgs } from 'src/cookies/cookie-consent-banner';

const getOptionalConsentCookieValue = (): Record<string, string | boolean> => {
  const consentCookieValue = getCookieWithKey(
    COOKIE_CONSENT_COOKIE_NAME,
    'optionalCookies'
  ).getValue();

  if (!consentCookieValue) {
    return {};
  }

  return (JSON.parse(consentCookieValue) as { optionalCookies: Record<string, string | boolean> })
    .optionalCookies;
};

const getCorrectCookieKey = (key: keyof OnCookieConsentChangeArgs) => {
  switch (key) {
    case 'analytics_accepted':
      return 'analytics';
    case 'preferences_accepted':
      return 'preferences';
    case 'marketing_accepted':
      return 'marketing';
    case 'social_media_accepted':
      return 'social_media';
  }
};

const formattingConsentChangeToNewKey = (consentChange: OnCookieConsentChangeArgs) =>
  (Object.keys(consentChange) as (keyof OnCookieConsentChangeArgs)[]).reduce(
    (acc, key) => {
      const correctKey = getCorrectCookieKey(key) as string;
      return { ...acc, [correctKey]: consentChange[key] };
    },
    {} as Record<string, boolean>
  );

export const generalAllowedAllConsentCookieOnChange =
  (querySelector: string, className: string) => (consentChange: OnCookieConsentChangeArgs) => {
    if (!document.querySelector(`${querySelector}`)) return;

    const changedCookies = {
      ...getOptionalConsentCookieValue(),
      ...formattingConsentChangeToNewKey(consentChange),
    };

    const allowedAll = Object.keys(changedCookies).every(
      (key) =>
        changedCookies[key] === COOKIE_CATEGORY_CONSENT_ACCEPTED_VALUE ||
        changedCookies[key] === true
    );

    if (allowedAll) {
      document.documentElement?.classList.add(className);
    } else {
      document.documentElement?.classList.remove(className);
    }
  };
